const HIGHEST_REVIEW_RATING = 5;
// This stock status for the product schema is static for now as per requirements. See Gitlab #2568
const IN_STOCK = 'InStock';

const schemaGenerator = data => {
  const { product, baseUrl, productReviews } = data;
  const productUrl = product.url || '';
  const styleColourPrices = product.availableColours.map(
    colour => colour.price
  );
  const pageUrlWithoutHash = `${baseUrl}${productUrl
    .replace(/^\//, '')
    .replace(/#[a-z0-9-]*$/, '')}`;

  const productSchema = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: product.styleName,
    brand: product.brand,
    url: pageUrlWithoutHash,
    image: {
      '@type': 'ImageObject',
      url: ((Array.isArray(product.images) && product.images[0]) || {}).detail,
    },
    review: (
      (Array.isArray(productReviews.reviews) && productReviews.reviews) ||
      []
    ).map(reviewData => ({
      '@type': 'Review',
      reviewRating: {
        '@type': 'Rating',
        ratingValue:
          reviewData.review &&
          reviewData.review.rating &&
          reviewData.review.rating.value,
        bestRating: HIGHEST_REVIEW_RATING,
      },
      author: {
        '@type': 'Person',
        name: reviewData.author && reviewData.author.name,
      },
    })),
    offers: {
      '@type': 'AggregateOffer',
      lowPrice: Math.min(...styleColourPrices),
      highPrice: Math.max(...styleColourPrices),
      offerCount: product.availableColours.length,
      priceCurrency: data.currency,
      availability: IN_STOCK,
    },
    model: product.availableColours.map(colour => ({
      '@type': 'ProductModel',
      name: colour.styleColourName,
      color: colour.name,
      brand: product.brand,
      url: `${baseUrl}${colour.url.replace(/^\//, '')}`,
      image: colour.image,
      description: colour.description,
      sku: colour.styleColourCode,
      offers: {
        '@type': 'Offer',
        price: colour.price,
        priceCurrency: data.currency,
        availability: IN_STOCK,
      },
    })),
  };

  if (
    product.ratings &&
    product.ratings.rating &&
    product.ratings.rating.total
  ) {
    productSchema.aggregateRating = {
      '@type': 'aggregateRating',
      ratingValue: product.ratings.rating.value,
      reviewCount: product.ratings.rating.total,
    };
  }

  return productSchema;
};

export default schemaGenerator;
